import SingleScheduleParticipant from "./SingleScheduleParticipant";

export default class ScheduleParticipants {
    constructor(participantsData) {
        this.start_nr = participantsData?.start_nr ?? null;
        this.participants = Array.isArray(participantsData.participants)
            ? participantsData.participants.map(p => new SingleScheduleParticipant(p))
            : [];
    }
}